module.exports = __webpack_public_path__ + "img/priority-lowest.aa0e9342.svg";